import { render, staticRenderFns } from "./ContributionSideInfo.vue?vue&type=template&id=c66b9db0"
import script from "./ContributionSideInfo.vue?vue&type=script&lang=js"
export * from "./ContributionSideInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports